import React from 'react';
const Footer = () => {
  return <div data-id="element-66">
      <div className="bg-gray-100 p-6 rounded-lg mt-10 mb-8 text-base text-gray-700" data-id="element-67">
        <p className="font-bold mb-3" data-id="element-68">
          THIS IS AN ADVERTISEMENT AND NOT AN ACTUAL NEWS ARTICLE, BLOG, OR
          CONSUMER PROTECTION UPDATE
        </p>
        <p className="mb-3 leading-relaxed" data-id="element-69">
          DISCLAIMER: Results may vary from person to person. MyoQuell™ does
          not intend to diagnose, treat, cure or prevent any disease and does
          not constitute medical advice.
        </p>
        <p className="mb-3 leading-relaxed" data-id="element-70">
          MARKETING DISCLOSURE: This website is a market place. As such you
          should know that the owner has a monetary connection to the product
          and services advertised on the site. The owner receives payment
          whenever a qualified lead is referred but that is the extent of it.
        </p>
        <p className="leading-relaxed" data-id="element-71">
          ADVERTISING DISCLOSURE: This website and the products & services
          referred to on the site are advertising marketplaces. This website is
          an advertisement and not a news publication. Any photographs of
          persons used on this site are models. The owner of this site and of
          the products and services referred to on this site only provides a
          service where consumers can obtain and compare.
        </p>
      </div>
      <div className="border-t pt-8 text-center text-gray-600 text-base" data-id="element-72">
        <p className="mb-3" data-id="element-73">
          © {new Date().getFullYear()} MyoQuell. All Rights Reserved.
        </p>
        <div className="flex justify-center gap-6" data-id="element-74">
          <span className="hover:text-green-600 cursor-pointer transition-colors" data-id="element-75">
            Privacy Policy
          </span>
          <span className="hover:text-green-600 cursor-pointer transition-colors" data-id="element-76">
            Terms of Service
          </span>
          <span className="hover:text-green-600 cursor-pointer transition-colors" data-id="element-77">
            Contact Us
          </span>
        </div>
      </div>
    </div>;
};
export default Footer;